import { IPlayerLink } from "./dto";

export interface INativeAppConf {
  id?: number;
  requirePin: boolean;
  pin?: number;
}

export interface ISetPinFormValues {
  pin: string;
  confirmPin: string;
}

export interface IUpdatePinFormValues {
  currentPin: string;
  newPin: string;
  confirmPin: string;
}

export class UpdatePinFormValues implements IUpdatePinFormValues {
  currentPin: string = "";
  newPin: string = "";
  confirmPin: string = "";

  constructor(init?: ISetPinFormValues) {
    Object.assign(this, init);
  }
}

export class SetPinFormValues implements ISetPinFormValues {
  pin: string = "";
  confirmPin: string = "";

  constructor(init?: ISetPinFormValues) {
    Object.assign(this, init);
  }
}

export const offlineLinks: IPlayerLink[] = [
  { label: "sidebar_btn_meetings", link: "meetings", icon: "fas fa-columns" },
  { label: "sidebar_btn_board", link: "board", icon: "fas fa-chalkboard" },
];
